module.exports = __webpack_public_path__ + "img/accessories.ae158c6f.svg";